export const bitsList = [
   'The importance of user testing and how to make a case for it to be included in your process',
   'How to introduce and implement Design Thinking within your business and bring cross-functional teams together',
   'Best practice in preparing for your first session and using the Workshop Kit',
   'The benefits and simplicity of using HostDesign for the prototyping stage',
   'How and where to recruit participants',
   'How to introduce and implement Design Thinking within your business and bring cross-functional teams together'
]

export const inputs = [
    {
        label:"Work Email Address",
        type:"email"
    },
    {
        label:"First Name",
        type:"text"
    },
    {
        label:"Last Name",
        type:"text"
    },
    {
        label:"Company Name",
        type:"text"
    }
]